import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
	selector: 'dc-text',
	template: `<span style="white-space: pre;">{{ text }}</span>`,
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true
})
export class TextComponent {
	@Input() text: string;
}
